import { API_URL } from "configuration/urls";
import { _auth } from '../../firebase';

// Simple async function without Redux
export const updatePersonalInformationAPI = async ({ firstName, lastName, email, mobileNumber, userId, storeId, restaurantId }) => {
  const requestBody = {
    firstName,
    lastName,
    email,
    userId,
    storeId,
    restaurantId
  };

  // Only include mobileNumber if it's provided
  if (mobileNumber !== undefined) {
    requestBody.mobileNumber = mobileNumber;
  }
  
  const response = await fetch(`${API_URL}api/v1/updateUserDetails`, {
    method: 'POST',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  });
  
  if (!response.ok) {
    throw new Error(`Failed to update personal information: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

// Get Orders API function
export const getOrdersAPI = async ({ storeId, userId, offset = '0', limit = '15' }) => {
  const accessToken = await _auth.currentUser.getIdToken(true);
  const params = new URLSearchParams({
    'filter.storeId': storeId,
    'filter.userId': userId,
    offset,
    limit,
    sortField: 'dateTimestamp',
    sortOrder: 'desc',
  });
  
  const response = await fetch(`${API_URL}orders/v1/orders?${params}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch orders: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

// Action Types
export const UPDATE_PERSONAL_INFO_REQUEST = 'UPDATE_PERSONAL_INFO_REQUEST';
export const UPDATE_PERSONAL_INFO_SUCCESS = 'UPDATE_PERSONAL_INFO_SUCCESS';
export const UPDATE_PERSONAL_INFO_FAILURE = 'UPDATE_PERSONAL_INFO_FAILURE';

// Action Creators
export const updatePersonalInfoRequest = () => ({
  type: UPDATE_PERSONAL_INFO_REQUEST,
});

export const updatePersonalInfoSuccess = (data) => ({
  type: UPDATE_PERSONAL_INFO_SUCCESS,
  payload: data,
});

export const updatePersonalInfoFailure = (error) => ({
  type: UPDATE_PERSONAL_INFO_FAILURE,
  payload: error,
}); 